import { BookOpenTextIcon, ClipboardCheckIcon, LightbulbIcon, MessagesSquareIcon, SearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  listLabel?: string;
  items?: string[];
  note?: string;
  benefit?: string;
  value: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: '150 Actividades y Desafíos para Enseñar Petróleo y Gas',
    description:
      '150 propuestas listas para utilizar o adaptar en clases sobre fundamentos, geología, exploración, perforación, producción, refinación, transporte, seguridad, ambiente y tecnología. Organizadas por nivel de dificultad.',
    note: 'Incluyen actividades de análisis, comparación, resolución de problemas, interpretación, argumentación y reflexión.',
    benefit: 'Materiales ya pensados para el aula: ahorra horas en cada trimestre.',
    value: 'USD 14',
    icon: LightbulbIcon,
  },
  {
    number: '02',
    title: 'Kit Completo de Evaluación de Petróleo y Gas',
    description: 'Recursos completos para evaluar conocimientos y competencias:',
    items: [
      'Evaluaciones diagnósticas',
      'Evaluaciones temáticas (por cada etapa)',
      'Evaluaciones integradoras',
      'Preguntas de respuesta breve y desarrollo',
      'Verdadero o falso con justificación',
      'Detección y corrección de errores',
      'Criterios de orientación para el docente',
      'Rúbricas',
      'Listas de cotejo',
    ],
    benefit: 'Nunca más construyas un examen desde cero bajo presión.',
    value: 'USD 14',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: '100 Casos y Situaciones Problemáticas de Petróleo y Gas para el Aula',
    description:
      '100 situaciones educativas ficticias para que los estudiantes apliquen conocimientos en contextos problemáticos.',
    listLabel: 'Los casos permiten trabajar:',
    items: [
      'Fundamentos y geología',
      'Exploración y recursos',
      'Perforación y producción',
      'Refinación y procesamiento',
      'Transporte y almacenamiento',
      'Seguridad y gestión de riesgos',
      'Ambiente y sostenibilidad',
      'Tecnología e innovación',
      'Situaciones integradoras',
    ],
    note: 'Promoviendo análisis de información, identificación de problemas, comparación de alternativas y justificación de respuestas.',
    benefit: 'Tus alumnos aprenden analizando situaciones reales de petróleo y gas.',
    value: 'USD 14',
    icon: SearchIcon,
  },
  {
    number: '04',
    title: 'Diccionario Docente de Petróleo y Gas: 200 Conceptos Explicados para el Aula',
    description: 'Una herramienta de consulta con 200 conceptos fundamentales explicados de forma clara y educativa.',
    listLabel: 'Incluye terminología relacionada con:',
    items: [
      'Petróleo y gas natural',
      'Geología petrolera',
      'Exploración',
      'Perforación y pozos',
      'Producción',
      'Refinación y procesamiento',
      'Transporte y almacenamiento',
      'Seguridad y riesgos',
      'Ambiente',
      'Tecnología e innovación',
    ],
    note: 'Con aclaraciones de conceptos que suelen confundirse, como porosidad/permeabilidad, peligro/riesgo, recurso/reserva, GLP/GNL y upstream/downstream.',
    value: 'USD 14',
    icon: BookOpenTextIcon,
  },
  {
    number: '05',
    title: '100 Preguntas y Temas de Debate sobre Petróleo y Gas para el Aula',
    description: 'Un recurso diseñado para generar participación, argumentación y pensamiento crítico.',
    listLabel: 'Contiene 100 propuestas sobre:',
    items: [
      'Fundamentos del petróleo y gas',
      'Geología y yacimientos',
      'Exploración',
      'Perforación y producción',
      'Refinación, gas y derivados',
      'Transporte y almacenamiento',
      'Seguridad y gestión de riesgos',
      'Ambiente y comunidades',
      'Tecnología e innovación',
      'Energía, transición energética y futuro',
    ],
    note: 'Las propuestas permiten trabajar mediante debate, reflexión individual, argumentación escrita, discusión grupal y comparación de diferentes perspectivas.',
    value: 'USD 14',
    icon: MessagesSquareIcon,
  },
];
